/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ab80eb3a391f46303097a5341b399a189e67309b";
